import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, List, ListItem, ModalHeader, Typography } from 'common/components';
import { CONSTRUCTION_HOUSES_ELEMENT_BLOCK } from '../../../../construction-houses-constants';

const forBusinessList = css`
  && {
    li:not(:last-child) {
      margin-bottom: 8px;

      @media (--only-mobile) {
        margin-bottom: 4px;
      }
    }

    margin-bottom: 24px;
  }
`;

export const ForBusiness: React.FC = () => (
  <>
    <ModalHeader title="Бонусы для бизнеса" />
    <ModalContent>
      <List listStyle="disc" className={forBusinessList}>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Заключите договор быстро и&nbsp;легко&nbsp;&mdash; мы&nbsp;максимально ускорили процесс
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Покупайте любым удобным способом&nbsp;&mdash; в&nbsp;магазинах, на&nbsp;сайте, по&nbsp;телефону
            или почте
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Получайте выгодные скидки на&nbsp;бренды за&nbsp;объём покупок
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Отслеживайте баланс счёта, статус заказа и&nbsp;историю покупок в&nbsp;личном кабинете
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Наши менеджеры всегда на&nbsp;связи по&nbsp;телефону или почте
          </Typography>
        </ListItem>
      </List>
      <Typography variant="m" size="body_long" adaptive={false}>
        Зарабатывайте вместе с&nbsp;нами&nbsp;&mdash; станьте партнёром Лемана ПРО!
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={CONSTRUCTION_HOUSES_ELEMENT_BLOCK}
        elementName="Подробности"
        elementText="Бонусы для бизнеса"
        href="/postavshchikam/uslugi/"
        wide
        variant="outline">
        Подробности
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
